import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import withPurchaseMethods from 'decorators/withPurchaseMethods';
import { createPaymentArrangements } from 'actions/purchases';
import { getSubmitSucceeded } from 'reducers';
import InputField from 'components/InputField';
import SelectField from 'components/SelectField';
import FormError from 'components/FormError';
import purchasePage from 'decorators/purchasePage';

const formatNum = (n) => (n < 10 ? '0' + n : n);

const getArrangementMinDate = () => {
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 1);

  return `${minDate.getFullYear()}-${formatNum(minDate.getMonth() + 1)}-${formatNum(minDate.getDate())}`;
};

let PaymentArrangements = ({
  handleSubmit,
  error,
  submitSucceeded,
  purchaseId,
  paymentMethods,
}) => {
  const redirect = `/purchases/${purchaseId}/view`;

  const minDateValue = getArrangementMinDate();

  const getCardOptionLabel = (card) => {
    if (card.echeck_type) {
      return card.account_number;
    }

    return `${card.is_default ? '(Default) ' : ''}${card.card_brand} ${card.card_last_four}`;
  };

  if (submitSucceeded) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <h1>Create Payment Arrangement</h1>
      <form onSubmit={handleSubmit}>
        <Field
          component={SelectField}
          name="card_id"
          label="Payment Method"
          empty="Choose a payment method"
          options={paymentMethods.map((card) => [
            card.id,
            getCardOptionLabel(card),
          ])}
        />
        <Field
          component={InputField}
          type="date"
          name="charge_date"
          min={minDateValue}
        />
        {error && <FormError error={error} />}
        <br />
        <button className="btn btn-default">Create</button>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.card_id) {
    errors.card_id = 'Required';
  }

  if (!values.charge_date) {
    errors.charge_date = 'Required';
  }

  return errors;
};

const mapStateToProps = (state) => ({
  submitSucceeded: getSubmitSucceeded(state, 'paymentArrangement'),
});

const mapDispatchToProps = (dispatch, { purchaseId }) => ({
  onSubmit: (values) => dispatch(createPaymentArrangements(purchaseId, values)),
});

PaymentArrangements = reduxForm({
  form: 'paymentArrangement',
  validate,
})(PaymentArrangements);

export default compose(
  purchasePage,
  withPurchaseMethods,
  connect(mapStateToProps, mapDispatchToProps),
)(PaymentArrangements);
